import { useMutation, useQueryClient } from 'react-query';

import { KimMessageBody } from '../../../../backend/src/matter/subset/kim/dto/kim-message-body.dto';
import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export type KimThreadSource = 'matter_overview' | 'subset_overview' | 'kim_page';

export const useCreateKimThread = (matterId?: string, subsetId?: string, source?: KimThreadSource) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();
  const queryKey = [QueryEntity.KimThreads, { subsetId }];

  return useMutation(
    async (payload: KimMessageBody) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { message: payload.message, files: payload.files, mentions: payload.mentions },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/thread`,
        fetchConfig,
      );
      if (!response.ok) {
        throw new Error('Creating Kim thread failed');
      }
      return response.json();
    },
    {
      onSuccess: (newThread) => {
        trackCustomEvent(TrackingEventsV2.KimCreateThread, { matterId, subsetId, source });
        queryClient.setQueryData(queryKey, (old: any) => [newThread, ...(old ?? [])]);
        setTimeout(() => {
          queryClient.invalidateQueries(queryKey);
          queryClient.invalidateQueries([QueryEntity.MatterKimThreads, { matterId }]);
        }, 3000);
      },
    },
  );
};
